export default __webpack_public_path__ + "static/media/fast-delivery.41edc8d8.png";